import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BaseElement, customElement } from '../base-element';
import './text';
import { Translate } from '../base-element/mixins/translation-mixin';

@customElement('ps-text-caption')
export class TextCaptionWC extends Translate(BaseElement) {
  /** Text-align */
  @property() textAlign: 'start' | 'center' | 'end' | 'justify' = 'start';

  @property() transform: 'none' | 'uppercase' = 'none';

  /** Typography variant */
  @property() variant: 'primary' | 'secondary' | 'tertiary' | 'danger' =
    'secondary';

  /** Truncate option */
  @property({ type: Boolean, reflect: true }) truncate?: boolean = false;

  /** Number of lines before truncating. Forwarded to `ps-text`, which clamps
   *  with `-webkit-line-clamp` and shows an ellipsis. Use it when a caption
   *  sits in a fixed-height row, so the overflow is signalled rather than cut
   *  off silently (PSTUDIO-4119). */
  @property({ type: Number, reflect: true, attribute: 'truncate-lines' })
  truncateLines?: number;

  render() {
    return html`
      <ps-text
        size="4xsmall"
        textAlign=${this.textAlign}
        variant=${this.variant}
        transform=${this.transform}
        ?truncate=${this.truncate}
        truncate-lines=${ifDefined(this.truncateLines)}
        data-testid="text-caption"
      >
        <slot></slot>
      </ps-text>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-text-caption': TextCaptionWC;
  }
  enum PSElementTagNameMap {
    'ps-text-caption' = 'ps-text-caption',
  }
}
